import React from "react";
import BarsListPage from "../settings/BarsListPage";

/**
 * Top-level "Templates" page (reachable from the App Bridge navigation menu).
 * Lists all saved free-shipping templates and offers a "Create template" button.
 */
export default function TemplatesPage() {
  return (
    <div
      style={{
        width: "100%",
        maxWidth: "100%",
        margin: 0,
        padding: "0 max(16px, 1.25vw) 2rem",
        boxSizing: "border-box",
        minHeight: "min(100vh, 960px)",
        backgroundColor: "var(--p-color-bg, transparent)",
      }}
    >
      <BarsListPage
        title="Templates"
        createLabel="Create template"
        resourceName={{ singular: "template", plural: "templates" }}
        emptyHeading="No templates yet"
        deleteTitle="Delete template?"
      />
    </div>
  );
}
